// Cột phải tab Cấu hình: thẻ "Tóm tắt nhanh" + mục lục (Anchor) nhảy tới từng nhóm.
import { Anchor, Button, Card, Tag } from "antd";
import { fmtNum } from "./xu-format-helpers";
import { programStatus, rankLaunchText } from "./xu-program-header";

const LINKS = [
    { key: "xu-sec-flags", href: "#xu-sec-flags", title: "Công tắc" },
    { key: "xu-sec-checkin", href: "#xu-sec-checkin", title: "Điểm danh" },
    { key: "xu-sec-missions", href: "#xu-sec-missions", title: "Nhiệm vụ" },
    { key: "xu-sec-rank", href: "#xu-sec-rank", title: "Hạng" },
    { key: "xu-sec-budget", href: "#xu-sec-budget", title: "Ngân sách & an toàn" },
    { key: "xu-sec-pages", href: "#xu-sec-pages", title: "Trang quy định" },
];

/** Số liệu ước tính từ cấu hình đang soạn (chưa nhân hệ số hạng). */
export function summarizeConfig(config) {
    const sum = (arr) => arr.reduce((s, v) => s + (Number(v) || 0), 0);
    const cycle = sum(config.checkinRewards);
    const missions = sum(Object.values(config.missions).map((m) => m.reward)) + (Number(config.allMissionsBonus) || 0);
    const maxDay = Math.max(0, ...config.checkinRewards.map(Number)) + missions;
    const topMult = Math.max(1, ...config.rankTiers.map((t) => Number(t.mult) || 1));
    const raw = Math.floor(maxDay * topMult);
    return { cycle, missions, maxDay: Math.min(raw, Number(config.dailyCap) || raw), capped: raw > (Number(config.dailyCap) || Infinity) };
}

const Row = ({ label, children }) => (
    <div className="flex justify-between gap-2 py-1 text-sm"><span className="text-gray-500">{label}</span><span className="text-right font-medium">{children}</span></div>
);

export function XuConfigSummary({ flags, config, onReload }) {
    const st = programStatus(flags);
    const s = summarizeConfig(config);
    return (
        <Card size="small" title="Tóm tắt nhanh" className="shadow-sm">
            <Row label="Trạng thái"><Tag color={st.color} className="!m-0">{st.text}</Tag></Row>
            <Row label="Hạng">{rankLaunchText(config.rankLaunchAt).replace("Hạng: ", "").replace("Hạng ", "")}</Row>
            <Row label="Một vòng điểm danh">{fmtNum(s.cycle)} Xu</Row>
            <Row label="Nhiệm vụ cả ngày">{fmtNum(s.missions)} Xu</Row>
            <Row label="Tối đa / người / ngày">≈ {fmtNum(s.maxDay)} Xu{s.capped ? " (đã chạm trần)" : ""}</Row>
            <div className="text-[11px] text-gray-400 mt-1">Ước tính gồm điểm danh ngày cao nhất + đủ 3 nhiệm vụ, nhân hệ số hạng cao nhất, không vượt trần ngày.</div>
            <Button size="small" block className="mt-2" onClick={onReload}>Tải lại từ máy chủ</Button>
        </Card>
    );
}

export function XuConfigSideNav() {
    return (
        <Card size="small" title="Mục lục" className="shadow-sm">
            <Anchor affix={false} showInkInFixed items={LINKS} targetOffset={16}
                getContainer={() => document.querySelector("main") || window} />
        </Card>
    );
}
